import { useState } from 'react';

import { Accordion } from '@/components/Accordion';
import { Typography } from '@/components/Typography';

export interface BlockchainElementProps {
  className?: string;
  description: React.ReactNode;
  title: React.ReactNode;
}

export const BlockchainElement = ({
  className,
  description,
  title,
}: BlockchainElementProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Accordion
      className={className}
      data-test-id='BlockchainElementAccordion'
      isOpen={isOpen}
      onClick={() => setIsOpen(!isOpen)}
      title={
        typeof title === 'string' ? (
          <Typography data-test-id='BlockchainElementTitle'>{title}</Typography>
        ) : (
          title
        )
      }
    >
      {description}
    </Accordion>
  );
};
